import { PHONE_ADDRESS_DB_SEPARATOR } from 'config';
import { uniqueId } from 'lodash';
import {
  formatPackedPhoneValue,
  normalizePhoneNumber,
} from './handlePhoneNumbers/phoneNumberMasks';

export type UnpackedEntity = {
  id: string;
  value: string;
  error?: string;
};

export const unpackPhoneNumbers = (
  phones: string | undefined,
  country: string | undefined,
): UnpackedEntity[] =>
  phones
    ? phones.split(PHONE_ADDRESS_DB_SEPARATOR).map((value) => ({
        id: uniqueId(),
        value: formatPackedPhoneValue(value, country),
        error: '',
      }))
    : [{ id: uniqueId(), value: '' }];

export const unpackAddress = (address: string | undefined): UnpackedEntity[] =>
  address
    ? address
        .split(PHONE_ADDRESS_DB_SEPARATOR)
        .map((value) => ({ id: uniqueId(), value }))
    : [{ id: uniqueId(), value: '' }];

export const packAddress = (unpackedEntities: UnpackedEntity[]) =>
  unpackedEntities.map(({ value }) => value).join(PHONE_ADDRESS_DB_SEPARATOR);

export const packPhoneNumbers = (unpackedPhoneNumbers: UnpackedEntity[]) =>
  unpackedPhoneNumbers
    .map(({ value }) => normalizePhoneNumber(value))
    .join(PHONE_ADDRESS_DB_SEPARATOR);
